import React, {useCallback, useState} from 'react';
import {Stack, styled, TextField, Typography} from '@mui/material';
import SkeletonWrap from './SkeletonWrap.js';
import RequiredAsterisk from './RequiredAsterisk.js';

const TextFieldLabel = styled(Typography, {shouldForwardProp: p=>!p.startsWith('$')})`
    color: ${p=>p.theme.palette.text[p.$focused ? 'primary' : 'secondary']};
    transition: color 200ms ease-out;
`;

const SCTextField = React.forwardRef((props, ref)=>{
    let {
        className,
        value,
        onChange: _onChange,
        onFocus: _onFocus,
        onBlur: _onBlur,
        label,
        skeleton,
        required,
        ...rest
    } = props;
    let onChange = useCallback(ev=>_onChange?.(ev.target.value, ev), [_onChange]);
    let [focused, setFocused] = useState();
    let onFocus = useCallback(()=>{
        setFocused(true);
        _onFocus?.();
    }, [_onFocus]);
    let onBlur = useCallback(()=>{
        setFocused(false);
        _onBlur?.();
    }, [_onBlur]);
    return <Stack direction="column" gap={1} sx={{width: '100%'}}>
      {label&&<SkeletonWrap skeleton={skeleton}>
        <TextFieldLabel $focused={focused}>
          {label}
          {required&&<RequiredAsterisk/>}
        </TextFieldLabel>
      </SkeletonWrap>}
      <SkeletonWrap skeleton={skeleton}>
        <TextField
          ref={ref}
          className={className}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          {...rest}/>
      </SkeletonWrap>
    </Stack>;
});

export default SCTextField;